export enum ApiError {
  networkError = 1,
  authError = 2,
  badRequest = 3,
  serverError = 4,
  notFoundError = 5,
}
